import { Component, OnInit } from '@angular/core';
import { AdminService, AlertService, CommonService } from '../../../_services/';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-marketing-list-entries',
  templateUrl: './marketing-list-entries.component.html',
  styleUrls: ['./marketing-list-entries.component.scss']
})
export class MarketingListEntriesComponent implements OnInit {
  entryList:any;
  constructor(
    private _admin : AdminService,
    private _common : CommonService,
    private _alert : AlertService
  ) { }

  ngOnInit() {
    this.getEntryList();

  }

  getEntryList(){
    this._common.showLoader(true);
    this._admin.getMarketingEntryList().subscribe(res=>{
      this._common.showLoader(false);
      this.entryList = res;
    },err=>{
      this._common.showLoader(false);
      this._alert.error( err.error && err.error.message?err.error.message:'Something went wrong!');

    })
  }

}
